import { __styles, __resetStyles, mergeClasses, shorthands } from '@griffel/react';
import { createCustomFocusIndicatorStyle } from '@fluentui/react-tabster';
import { tokens } from '@fluentui/react-theme';
export const listItemClassNames = {
  root: 'fui-ListItem',
  media: 'fui-ListItem__media',
  header: 'fui-ListItem__header',
  contentWrapper: 'fui-ListItem__contentWrapper',
  headerMedia: 'fui-ListItem__headerMedia',
  contentMedia: 'fui-ListItem__contentMedia',
  endMedia: 'fui-ListItem__endMedia'
};
const useRootBaseStyles = /*#__PURE__*/__resetStyles("rigpsx1", "r1tw60jj", [".rigpsx1{padding-top:0;padding-right:10px;padding-bottom:0;padding-left:10px;margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;text-indent:0;list-style-type:none;}", ".rigpsx1[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);}", ".r1tw60jj{padding-top:0;padding-left:10px;padding-bottom:0;padding-right:10px;margin-top:0;margin-left:0;margin-bottom:0;margin-right:0;text-indent:0;list-style-type:none;}", ".r1tw60jj[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);}"]);
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  contentWrapper: {
    Be2twd7: "fy9rknc"
  },
  contentWrapperWithoutMedia: {
    Bw0ie65: "fsyjsko"
  },
  truncate: {
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    j4b8c3: "fv6wr3j",
    ygn44y: "f1cmbuwj"
  },
  rootSelected: {
    De3pzq: "f1nfm20t"
  },
  rootClickable: {
    Bceei9c: "f1k6fduh",
    Jwef8y: "f1knas48"
  }
}, {
  d: [".fy9rknc{font-size:var(--fontSizeBase200);}", ".fsyjsko{grid-column-end:4;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".fv6wr3j{text-wrap:nowrap;}", ".f1cmbuwj{text-overflow:ellipsis;}", ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}", ".f1k6fduh{cursor:pointer;}"],
  h: [".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}"]
});
/**
 * Apply styling to the ListItem slots based on the state
 */
export const useListItemStyles_unstable = state => {
  const rootBaseStyles = useRootBaseStyles();
  const styles = useStyles();
  state.root.className = mergeClasses(listItemClassNames.root, rootBaseStyles, (state.selectable || state.navigable) && styles.rootClickable, state.selected && styles.rootSelected, state.root.className);
  if (state.header) {
    var _state_header;
    state.header.className = mergeClasses(state.truncateHeader && styles.truncate, (_state_header = state.header) === null || _state_header === void 0 ? void 0 : _state_header.className);
  }
  if (state.contentWrapper) {
    var _state_contentWrapper;
    state.contentWrapper.className = mergeClasses(styles.contentWrapper, state.truncateContent && styles.truncate, !state.contentMedia && styles.contentWrapperWithoutMedia, (_state_contentWrapper = state.contentWrapper) === null || _state_contentWrapper === void 0 ? void 0 : _state_contentWrapper.className);
  }
  return state;
};
//# sourceMappingURL=useListItemStyles.styles.js.map